import { components } from "react-select";

const Option = (props: any) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          className="container_dropdown_option"
        />{" "}
        <label className="container_dropdown_label">{props.label}</label>
      </components.Option>
    </div>
  );
};

export default Option;
